import transformCategory from '../transformCategory'

const hartuCategoriesTransformer = data =>
    data?.map(category => transformCategory(category))


export default hartuCategoriesTransformer